import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@mgc/react-components';

class MigrationNotice extends Component {
    constructor(props) {
        super();
        this.state = {
            visible: Object.prototype.hasOwnProperty.call(props, 'visible')
                ? props.visible
                : true,
        };
    }

    _renderNotice() {
        if (!this.state.visible) {
            return null;
        }

        return (
            <div>
                <p>
                    As part of the ongoing transition from Mentor Graphics to
                    Siemens EDA, Mentor Advantge has transitioned to this new
                    URL with Siemens branding.
                </p>
                {/* <p> */}
                {/*     Siemens Advantage is found at{' '} */}
                {/*     <a href="">https://advantage.sw.siemens.com/</a> */}
                {/* </p> */}
                <p className="m-b-xs">
                    In order to simplify the login process across Siemens web
                    sites, Siemens Advantage has been configured to use the
                    Siemens DISW login system. This brings it in-line with
                    Support Center and other Siemens web properties. Most users
                    won&apos;t notice any changes and will be able to log-in
                    with their existing password. Users with log-in trouble
                    should reach out to their local contact for assistance.
                </p>
            </div>
        );
    }

    _renderToggle() {
        if (this.state.visible) {
            return null;
        }

        return (
            <a
                className="cursor-pointer text-mute text-small"
                onClick={() => this.setState({ visible: true })}
            >
                <em>Show details...</em>
            </a>
        );
    }

    render() {
        return (
            <div className="card m-b-0">
                <div className="card-header bg-success text-small p-a-xs text-inverse">
                    <Icon className="m-x-xs" name="icon-info" /> Welcome to
                    Siemens Advantage
                </div>
                <div className="card-body p-a-sm">
                    <div className="row">
                        <div className="col-md-12 migration-panel">
                            {this._renderNotice()}
                            {this._renderToggle()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MigrationNotice.propTypes = {
    visible: PropTypes.bool,
};

export default MigrationNotice;



// WEBPACK FOOTER //
// ./app/components/MigrationNotice.jsx